import type { ConsentState } from '../lib/probe-telemetry.js';

interface MeasurementConsentProps {
  state: ConsentState;
  onDecision: (decision: 'granted' | 'denied') => void;
}

export function MeasurementConsent({ state, onDecision }: MeasurementConsentProps) {
  if (state === 'granted' || state === 'denied' || state === 'unavailable') return null;
  return (
    <aside className="measurement-consent" aria-label="Optional audience measurement" role="dialog" aria-live="polite">
      <div>
        <strong>Help us measure whether this checker is useful?</strong>
        <p>Optional first-party measurement sends the selected image through our verification server only for ephemeral processing; it is never retained. We record pseudonymous usage events, never the image, filename, evidence, metadata, or file hash. Decline to keep verification entirely in this browser.</p>
      </div>
      <div className="measurement-consent__actions">
        <button type="button" onClick={() => onDecision('granted')}>Allow measurement</button>
        <button type="button" className="measurement-consent__decline" onClick={() => onDecision('denied')}>Decline</button>
      </div>
    </aside>
  );
}
